import { useState } from "react";
import { FiDownload, FiCheck } from "react-icons/fi";
import styles from "./FileBubble.module.css";

const getFileStyle = (fileType = "", fileName = "") => {
  const t = fileType.toLowerCase();
  const n = (fileName || "").toLowerCase();
  if (t.includes("pdf") || n.endsWith(".pdf"))
    return { bg: "#e8453c", label: "PDF", abbr: "PDF" };
  if (t.includes("word") || t.includes("doc") || n.endsWith(".docx") || n.endsWith(".doc"))
    return { bg: "#2b7cd3", label: "DOCX", abbr: "W" };
  if (t.includes("sheet") || t.includes("excel") || t.includes("csv") || n.endsWith(".xlsx") || n.endsWith(".xls") || n.endsWith(".csv"))
    return { bg: "#1d7a45", label: "XLSX", abbr: "X" };
  if (t.includes("presentation") || t.includes("powerpoint") || n.endsWith(".pptx") || n.endsWith(".ppt"))
    return { bg: "#c7532a", label: "PPTX", abbr: "P" };
  if (t.includes("zip") || t.includes("rar") || n.endsWith(".zip") || n.endsWith(".rar"))
    return { bg: "#7c5cbf", label: "ZIP", abbr: "Z" };
  if (t.includes("text") || n.endsWith(".txt"))
    return { bg: "#555", label: "TXT", abbr: "T" };
  if (n.endsWith(".mp3") || n.endsWith(".wav") || t.includes("audio"))
    return { bg: "#e67e22", label: "MP3", abbr: "♪" };
  return { bg: "#6c63ff", label: "FILE", abbr: "F" };
};

const formatSize = (bytes) => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const FileBubble = ({ file, fileName, fileSize, fileType, isOwn }) => {
  const [downloaded, setDownloaded] = useState(false);
  const { bg, label, abbr } = getFileStyle(fileType, fileName);
  const ext    = (fileName?.split(".").pop() || "").toUpperCase();
  const sizeStr = formatSize(fileSize);

  const handleDownload = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Trigger download
    const a = document.createElement("a");
    a.href = file;
    a.download = fileName || "file";
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // Show checkmark — hide download button like WhatsApp
    setDownloaded(true);
  };

  return (
    <div className={`${styles.container} ${isOwn ? styles.own : styles.other}`}>
      {/* Colored file icon */}
      <div className={styles.iconBox} style={{ background: bg }}>
        <span className={styles.abbr}>{abbr}</span>
        <span className={styles.ext}>{ext || label}</span>
      </div>

      {/* File info */}
      <div className={styles.info}>
        <span className={styles.name}>{fileName || "File"}</span>
        <span className={styles.meta}>
          {ext || label}{sizeStr ? ` • ${sizeStr}` : ""}
        </span>
      </div>

      {/* Download button — turns to checkmark after click, like WhatsApp */}
      {!downloaded ? (
        <button
          className={styles.downloadCircle}
          onClick={handleDownload}
          title="Download"
        >
          <FiDownload size={15} />
        </button>
      ) : (
        <div className={`${styles.downloadCircle} ${styles.downloaded}`}>
          <FiCheck size={15} />
        </div>
      )}
    </div>
  );
};

export default FileBubble;
